

















import { Component, Vue } from "vue-property-decorator";
import DisclaimerAccordion from "@/components/designer/reusable/DisclaimerAccordion.vue";

@Component({
  components: { DisclaimerAccordion }
})
export default class FabricAlignmentDisclaimer extends Vue {}
